import React from "react";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";

const parkerVideos = [
  {
    txt: "Parker's Bent Axis eReady Pumps F1e and F12e",
    link: "https://youtu.be/V1u4LCj6WBE?feature=shared",
  },
  {
    txt: "Variable Displacement Axial Piston Pump PC3 Product Animation",
    link: "https://youtu.be/jjDn-QpVPb0?feature=shared",
  },
  {
    txt: "How Parker Calzoni High Torque Radial Piston Motors Work - Animation",
    link: "https://youtu.be/mhiwUVBwV0M?feature=shared",
  },
  {
    txt: "High Pressure Piston Pumps - P2/P3 Series Animation | Parker Hannifin",
    link: "https://youtu.be/keeu2jGIN3U?feature=shared",
  },
  {
    txt: "Parker Hannifin Overview",
    link: "https://youtu.be/rbPMKgHF8dM?feature=shared",
  },
];

const VideoLib = () => {
  return (
    <div className="max-w-6xl mx-auto py-8 px-4">
      {/* Logo */}
      <div className="flex items-center space-x-2">
        <img
          src="/assets/image/parker_store.png"
          alt="Parker Store"
          className="h-10"
        />
      </div>

      {/* Title */}
      <h2 className="text-2xl font-semibold mt-4">ParkerStore Video Library</h2>

      {/* Video Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
        {parkerVideos.map((item, index) => {
          // Extract YouTube video ID from the link
          const videoId =
            item.link.split("v=")[1]?.split("&")[0] ||
            item.link.split("/").pop();

          return (
            <div key={index} className="relative border pb-3">
              {/* Embedded Video */}
              <div className="relative overflow-hidden shadow-lg">
                <iframe
                  width="100%"
                  height="315"
                  src={`https://www.youtube.com/embed/${videoId}`}
                  title={item.txt}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>

              {/* Video Title */}
              <h3 className="mt-2 px-4 py-3 text-lg font-medium">{item.txt}</h3>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default VideoLib;
